var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spr-simple-radio",class:{ 'spr-danger': !_vm.isValid },on:{"click":_vm.onRadioClick}},[_c('input',{attrs:{"id":_vm.id,"type":"radio","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.isChecked}}),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }